import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { Document, Page, Path, StyleSheet, Svg, Text, View } from "@react-pdf/renderer";
import { Style } from "@react-pdf/types";
import Decimal from "decimal.js";
import { FC } from "react";
import { IPaymentSession } from "src/types/types";
import "./fonts";

export interface IPdfTransactions {
	// langValues: {
	//     userId: string;
	//     title: string;
	//     details: string;
	//     date: string;
	//     transaction: string;
	//     address1: string;
	//     address2: string;
	//     copyright: string;
	//     page: string;
	//     dateTime: string;
	//     transactionId: string;
	//     description: string;
	//     in: string;
	//     out: string;
	//     balance: string;
	//     total: string;
	// };
	// id: string;
	// transactions: ITransactionVO[] | null;
	// targetTransaction?: ITransactionVO;
	// printAll?: boolean;
}

export type PDFProps = {
	// auth: AuthDataVO;
	// transactionsData: IPdfTransactions;
	// project: TProject;
	session: IPaymentSession;
};

export const PDF: FC<PDFProps> = ({ session }) => { useLocale(); return ((
	<Document>
		<Page size="A4" style={styles.body}>
			{/* <Header auth={auth} transactionsData={transactionsData} project={project} /> */}

			<Text style={styles.text_12_500}>{msg("paymentInfo")}</Text>
			<View style={{ height: 10 }} />

			<Table sessionData={session} />

			<View style={styles.pageFooter} fixed>
				<Text style={styles.text_8_400} render={({ pageNumber, totalPages }) => msg("templatePage_1bcd3a91", { v0: pageNumber, v1: totalPages })} />
			</View>
		</Page>
	</Document>
)); };

interface IPDFTableProps {
	sessionData: IPaymentSession;
}

const SectionTitle: FC<{ children: React.ReactNode }> = ({ children }) => { useLocale(); return ((
	<View style={{ marginTop: 16, marginBottom: 0 }}>
		<Text style={styles.text_12_500}>{children}</Text>
		<View style={{ height: 1, backgroundColor: "#000", marginTop: 4 }} />
	</View>
)); };

const FieldRow: FC<{ label: string; value: string | number | undefined | null }> = ({ label, value }) => { useLocale(); return ((
	<View style={[styles.Row, { borderBottom: "0.2pt solid #ccc" }]} wrap={false}>
		<Column size={35} style={styles.text_8_500} l>
			{label}
		</Column>
		<Column size={65} style={styles.text_8_400} l>
			{value != null ? String(value) : "---"}
		</Column>
	</View>
)); };

const Table: FC<IPDFTableProps> = ({ sessionData }) => {
	useLocale();
	const s = sessionData;

	return (
		<View>
			{/* Status */}
			<SectionTitle>{msg("status")}</SectionTitle>
			<FieldRow label={msg("amount")} value={s.amount != null ? `${new Decimal(s.amount).dividedBy(100).toString()} ${s.currency ?? ""}` : undefined} />
			<FieldRow label={msg("id_3843971d")} value={s.id} />
			<FieldRow label={msg("status")} value={s.status} />
			<FieldRow label={msg("failReason")} value={s.fail_reason ?? "---"} />

			{/* Common info */}
			<SectionTitle>{msg("commonInfo")}</SectionTitle>
			<FieldRow label={msg("createdAt")} value={s.created_at} />
			<FieldRow label={msg("updatedAt")} value={s.updated_at} />
			<FieldRow label={msg("merchantId")} value={s.mid} />
			<FieldRow label={msg("paymentId")} value={s.payment_id} />

			{/* Payer info */}
			<SectionTitle>{msg("payerInfo")}</SectionTitle>
			<FieldRow label={msg("personName")} value={s.req?.customer?.name} />
			<FieldRow label={msg("eMail")} value={s.email} />
			<FieldRow label={msg("ip")} value={s.ip} />
			<FieldRow label={msg("country")} value={s.country} />

			{/* Payment info */}
			<SectionTitle>{msg("paymentInfo")}</SectionTitle>
			<FieldRow label={msg("channelId")} value={s.channel_id} />
			<FieldRow label={msg("channelAlias")} value={s.channel_alias} />
			<FieldRow label={msg("terminalId")} value={s.terminal_id} />
			<FieldRow label={msg("terminalType")} value={s.terminal_id} />
			<FieldRow label={msg("availableChannels")} value={s.total_channels} />
			<FieldRow label={msg("webhookStatus")} value={s.webhook_status} />
			<FieldRow label={msg("webhookAt")} value={s.webhook_at} />

			{s.instrument === "card" && s.payload?.card ? (
				<>
					<SectionTitle>{msg("paymentCard")}</SectionTitle>
					<FieldRow label={msg("bank")} value={s.payload.card.bank} />
					<FieldRow label={msg("bin")} value={s.payload.card.bin} />
					<FieldRow label={msg("category")} value={s.payload.card.category} />
					<FieldRow label={msg("countryCode")} value={s.payload.card.countryCode} />
					<FieldRow label={msg("cardholderName")} value={s.payload.card.country} />
					<FieldRow label={msg("cardType")} value={s.payload.card.type} />
					<FieldRow label={msg("mask")} value={s.payload.card.mask} />
					<FieldRow label={msg("network")} value={s.payload.card.network} />
					<FieldRow label={msg("token")} value={s.payload.card.token} />
					{s.instrument_country ? <FieldRow label={msg("instrumentCountry")} value={s.instrument_country} /> : null}
				</>
			) : (
				<>
					<SectionTitle>{msg("paymentInstrument")}</SectionTitle>
					<FieldRow label={msg("instrument")} value={s.instrument} />
					<FieldRow label={msg("instrumentType")} value={s.instrument_type} />
					<FieldRow label={msg("instrumentData")} value={s.instrument_data} />
					<FieldRow label={msg("instrumentName")} value={s.instrument_name} />
					{s.instrument_country ? <FieldRow label={msg("instrumentCountry")} value={s.instrument_country} /> : null}
				</>
			)}
		</View>
	);
};

interface IFooterProps {
	address1: string;
	address2: string;
	copyright: string;
	page: string;
}
//@ts-ignore
const Footer: FC<IFooterProps> = ({ address1, address2, copyright, page }) => {
	useLocale();
	const getCopyright = (text: string) => {
		if (text.indexOf("©") != -1) {
			const vals = text.split("©");
			return (
				<View style={{ display: "flex", flexDirection: "row", gap: 1, alignItems: "center" }}>
					<Text style={styles.text_8_500}>{vals[0]}</Text>
					<Copyright height={7} />
					<Text style={styles.text_8_500}>{vals[1]}</Text>
				</View>
			);
		} else {
			return <Text style={styles.text_8_500}>{text}</Text>;
		}
	};

	return (
		<View style={styles.Footer} fixed>
			<View style={{ display: "flex", flexDirection: "row", gap: 16 }}>
				<Text style={styles.text_6_400}>{address1}</Text>
				<Text style={styles.text_6_400}>{address2}</Text>
			</View>
			<View style={{ height: 12 }} />
			<View style={{ display: "flex", flexDirection: "row", gap: 16 }}>
				{getCopyright(copyright)}
				<Text
					style={[styles.text_8_500, { marginLeft: "auto" }]}
					render={({ pageNumber, totalPages }) => `${page} ${pageNumber} / ${totalPages}`}
					fixed
				/>
			</View>
		</View>
	);
};
//@ts-ignore
const Header: FC<PDFProps> = ({}) => {
	return null;
	// return (
	//     <View style={styles.header} fixed>
	//         <View style={styles.headerColumn}>
	//             <View style={{ height: 24 }} />
	//             <Text style={styles.text_12_500}>{auth.persona?.name}</Text>
	//             <View style={{ height: 8 }} />
	//             <Text style={styles.text_8_400}>{auth.contacts?.email}</Text>
	//             <View style={{ height: 4 }} />
	//             <Text style={styles.text_8_400}>{`${transactionsData.langValues.userId}: ${transactionsData.id}`}</Text>
	//             <View style={{ height: 48 }} />
	//         </View>
	//         <View style={{ ...styles.headerColumn, alignItems: 'flex-end' }}>
	//             <Text style={styles.text_6_400}>{transactionsData.langValues.title}</Text>
	//             <View style={{ height: 6 }} />
	//             <Text style={styles.text_18_600}>{transactionsData.langValues.details}</Text>
	//             <Text style={styles.text_8_400}>{transactionsData.langValues.date}</Text>
	//             <View style={{ height: 48 }} />
	//         </View>
	//     </View>
	// );
};

interface IColumnProps {
	// Start Border Column
	s?: boolean;
	// End Border Column
	e?: boolean;
	// Top Border Column
	t?: boolean;
	// Bottom Border Column
	b?: boolean;
	name?: string;
	size: number;
	children?: React.ReactNode;
	style?: Style;

	l?: boolean;
}

function Column(props: IColumnProps) {
	useLocale();
	return (
		<Text
			style={[
				{
					overflow: "hidden",
					display: "flex",
					flexWrap: "wrap",
					width: props.size + "%",
					justifyContent: "center",
					alignItems: "center",
					paddingTop: 4,
					paddingBottom: 4,
					paddingRight: 2,
					paddingLeft: 2,
					...(props.l ? { textAlign: "left" } : { textAlign: "right" }),
					...(props.b && { borderBottom: "0.2pt solid #000000" }),
					...(props.s && { borderLeft: "1pt solid #000000" }),
					...(props.t && { borderTop: "1pt solid #000000" }),
					...(props.e && { borderRight: "1pt solid #000000" }),
				},
				props.style ? props.style : {},
			]}>
			{props.name || props.children || null}
		</Text>
	);
}

const Copyright = (props: { height: number }) => {
	useLocale();
	return (
		<Svg width={props.height} height={props.height} viewBox={`0 0 22 22`}>
			<Path
				fill="#000000"
				stroke="none"
				d="
M 18.75 3.25
Q 15.55 0 11 0 6.45 0 3.2 3.25 0 6.45 0 11 0 15.55 3.2 18.75 6.45 22 11 22 15.55 22 18.75 18.75 22 15.55 22 11 22 6.45 18.75 3.25
M 17.1 4.85
Q 19.7 7.4 19.7 11 19.7 14.6 17.1 17.15 14.55 19.7 11 19.7 7.4 19.7 4.85 17.15 2.3 14.6 2.3 11 2.3 7.4 4.85 4.85 7.4 2.3 11 2.3 14.55 2.3 17.1 4.85
M 14.1 6
Q 12.7 5.2 11.05 5.2 8.65 5.2 6.95 6.9 5.25 8.6 5.25 11 5.25 13.4 6.95 15.05 8.65 16.75 11.05 16.75 12.7 16.75 14.1 15.95 15.5 15.2 16.2 13.8
L 14.15 12.7
Q 13.2 14.55 11.05 14.55 9.6 14.55 8.6 13.5 7.55 12.45 7.55 11 7.55 9.55 8.6 8.5 9.6 7.45 11.05 7.45 13.2 7.45 14.15 9.3
L 16.2 8.2
Q 15.5 6.85 14.1 6 Z"
			/>
		</Svg>
	);
};

// const LogoAmazing = () => {
//     return (
//         <Svg width="101" height="32" viewBox="0 0 101 32">
//             <Path
//                 d="M0.888916 12.0178C0.888916 7.42971 0.888916 5.13568 1.90781 3.4433C2.50612 2.44952 3.33844 1.6172 4.33222 1.0189C6.0246 0 8.31863 0 12.9067 0H20.8711C25.4592 0 27.7532 0 29.4456 1.0189C30.4394 1.6172 31.2717 2.44952 31.87 3.4433C32.8889 5.13568 32.8889 7.42971 32.8889 12.0178V19.9822C32.8889 24.5703 32.8889 26.8643 31.87 28.5567C31.2717 29.5505 30.4394 30.3828 29.4456 30.9811C27.7532 32 25.4592 32 20.8711 32H12.9067C8.31863 32 6.0246 32 4.33222 30.9811C3.33844 30.3828 2.50612 29.5505 1.90781 28.5567C0.888916 26.8643 0.888916 24.5703 0.888916 19.9822V12.0178Z"
//                 fill="#14171F"
//             />
//             <Path
//                 d="M16.1524 24.9328C11.1893 24.9328 7.15015 20.9219 7.15015 15.9906C7.15015 11.0592 11.1879 7.04834 16.1524 7.04834C17.7714 7.04834 19.3532 7.43039 20.728 8.15099L19.4359 10.5439C18.4582 10.03 17.3218 9.75942 16.1538 9.75942C12.7062 9.75942 9.90268 12.5548 9.90268 15.9906C9.90268 19.4263 12.7076 22.2217 16.1538 22.2217C17.719 22.2217 18.9891 21.7485 19.9889 21.0497C18.3272 19.2169 17.8831 17.4195 17.8831 16.0205C17.8831 13.5378 19.6786 11.5188 21.885 11.5188C24.0915 11.5188 25.7063 13.512 25.7063 16.0545C25.7063 17.4141 25.1244 19.2319 23.9632 20.8675C24.45 21.1938 25.003 21.5228 25.6332 21.8492L24.3521 24.2489C23.4902 23.8016 22.7373 23.342 22.0822 22.877C20.575 24.0925 18.5988 24.9328 16.1552 24.9328H16.1524ZM21.8837 14.2298C21.1087 14.2298 20.6315 15.2727 20.6315 16.0205C20.6315 16.8512 20.9059 17.9131 21.8837 19.0674C22.6146 17.9416 22.9552 16.7751 22.9552 16.0558C22.9552 14.9804 22.3912 14.2312 21.885 14.2312L21.8837 14.2298Z"
//                 fill="white"
//             />
//             <Path
//                 d="M40.1615 11.3837C40.1615 9.2574 41.4865 7.67725 43.5154 7.67725C44.6009 7.67725 45.2745 8.0534 45.6944 8.5712V7.82519H47.9851V14.9123H45.7007L45.6257 14.3661C45.1995 14.7942 44.4045 15.0602 43.5138 15.0602C41.4849 15.0602 40.1599 13.4958 40.1599 11.3837H40.1615ZM44.122 12.978C45.0063 12.978 45.6576 12.3138 45.6576 11.3695C45.6576 10.4252 45.0063 9.76103 44.122 9.76103C43.2376 9.76103 42.5352 10.389 42.5352 11.3695C42.5352 12.35 43.2248 12.978 44.122 12.978Z"
//                 fill="#14171F"
//             />
//             <Path
//                 d="M50.0586 7.82519H52.2216L52.2966 8.5712C52.8059 7.93693 53.6743 7.67725 54.5203 7.67725C55.4781 7.67725 56.3992 8.07543 56.7807 8.85764C57.3649 8.04553 58.2924 7.67725 59.1991 7.67725C60.5847 7.67725 61.8953 8.57749 61.8953 10.3056V14.9123H59.5375V10.9697C59.5375 10.1797 58.9533 9.80352 58.3626 9.80352C57.772 9.80352 57.1494 10.1797 57.1494 10.9697V14.9123H54.7917V10.9697C54.7917 10.1797 54.1851 9.80352 53.6168 9.80352C53.0485 9.80352 52.4195 10.1797 52.4195 10.9697V14.9123H50.0618V7.82519H50.0586Z"
//                 fill="#14171F"
//             />
//             <Path
//                 d="M63.3576 11.3837C63.3576 9.2574 64.6825 7.67725 66.7114 7.67725C67.7969 7.67725 68.4706 8.0534 68.8904 8.5712V7.82519H71.1811V14.9123H68.8968L68.8218 14.3661C68.3955 14.7942 67.6006 15.0602 66.7098 15.0602C64.6809 15.0602 63.356 13.4958 63.356 11.3837H63.3576ZM67.318 12.978C68.2024 12.978 68.8537 12.3138 68.8537 11.3695C68.8537 10.4252 68.2024 9.76103 67.318 9.76103C66.4337 9.76103 65.7313 10.389 65.7313 11.3695C65.7313 12.35 66.4209 12.978 67.318 12.978Z"
//                 fill="#14171F"
//             />
//             <Path
//                 d="M75.8391 9.74543H72.739V7.8269H78.5337V9.35512L75.4496 12.9939H78.7587V14.9124H72.739V13.3921L75.8391 9.74543Z"
//                 fill="#14171F"
//             />
//             <Path
//                 d="M81.3498 4.37061C82.1128 4.37061 82.6523 4.88683 82.6523 5.647C82.6523 6.40717 82.1128 6.9171 81.3498 6.9171C80.5867 6.9171 80.0615 6.40088 80.0615 5.647C80.0615 4.89313 80.5851 4.37061 81.3498 4.37061ZM82.5709 7.82522V14.9123H80.2132V7.82522H82.5709Z"
//                 fill="#14171F"
//             />
//             <Path
//                 d="M84.4417 14.9123V7.82519H86.6063L86.6813 8.5712C87.1905 7.93693 88.0589 7.67725 88.905 7.67725C90.2602 7.67725 91.5628 8.61526 91.5628 10.3056V14.9123H89.2051V10.9697C89.2051 10.1797 88.5681 9.80352 87.9998 9.80352C87.4316 9.80352 86.8026 10.1797 86.8026 10.9697V14.9123H84.4448H84.4417Z"
//                 fill="#14171F"
//             />
//             <Path
//                 d="M94.2575 15.0964C94.9232 15.7307 95.5761 16.0187 96.4668 16.0187C97.2682 16.0187 98.3233 15.6205 98.3233 14.5644V14.1662C97.9115 14.6683 97.2155 15.0602 96.205 15.0602C94.2878 15.0602 92.8799 13.4958 92.8799 11.3758C92.8799 9.25582 94.2878 7.67725 96.205 7.67725C97.2155 7.67725 97.9115 8.07543 98.3233 8.5712L98.3984 7.82519H100.683V14.6604C100.683 17.0008 98.5037 18.0112 96.4971 18.0112C94.9391 18.0112 93.6669 17.4131 92.8591 16.4751L94.2591 15.0948L94.2575 15.0964ZM95.2169 11.3758C95.2169 12.3359 95.8538 13.0079 96.7669 13.0079C97.68 13.0079 98.3169 12.3359 98.3169 11.3758C98.3169 10.4158 97.68 9.75159 96.7669 9.74372C95.8538 9.74372 95.2169 10.4158 95.2169 11.3758Z"
//                 fill="#14171F"
//             />
//             <Path
//                 d="M40.7952 17.5659H41.986V18.622C42.3835 17.9657 43.2216 17.418 44.3438 17.418C45.6161 17.418 46.5372 17.9798 46.9713 18.9084C47.4582 17.9861 48.432 17.418 49.5989 17.418C51.4714 17.418 52.5856 18.5842 52.5856 20.3186V24.6514H51.3948V20.6066C51.3948 19.3003 50.6604 18.5244 49.4105 18.5244C48.242 18.5244 47.2762 19.3286 47.2762 20.5846V24.6514H46.0854V20.6066C46.0854 19.3003 45.3511 18.5244 44.1459 18.5244C42.9406 18.5244 41.9829 19.3444 41.9829 20.6286V24.6514H40.792V17.5643L40.7952 17.5659Z"
//                 fill="#14171F"
//             />
//             <Path
//                 d="M54.356 21.1104C54.356 19.036 55.9874 17.4197 58.1744 17.4197C60.3613 17.4197 61.9928 19.036 61.9928 21.1104C61.9928 23.1847 60.3613 24.8011 58.1744 24.8011C55.9874 24.8011 54.356 23.1847 54.356 21.1104ZM58.1744 23.7088C59.6861 23.7088 60.8019 22.5725 60.8019 21.1104C60.8019 19.6483 59.6861 18.5119 58.1744 18.5119C56.6626 18.5119 55.5468 19.6483 55.5468 21.1104C55.5468 22.5725 56.6626 23.7088 58.1744 23.7088Z"
//                 fill="#14171F"
//             />
//             <Path
//                 d="M63.8572 24.653V17.5659H65.0544V18.6283C65.4583 17.972 66.3123 17.418 67.4585 17.418C69.3533 17.418 70.4915 18.5181 70.4915 20.3406V24.6514H69.3006V20.6286C69.3006 19.2484 68.5743 18.5244 67.2717 18.5244C66.0441 18.5244 65.048 19.3585 65.048 20.6507V24.6514H63.8572V24.653Z"
//                 fill="#14171F"
//             />
//             <Path
//                 d="M75.9638 17.4197C77.7613 17.4197 79.431 18.6677 79.431 20.7484C79.431 20.9624 79.423 21.1985 79.3943 21.3984H73.472C73.547 22.6905 74.5271 23.7308 76.0245 23.7308C77.0349 23.7308 77.7772 23.265 78.2928 22.5426L79.1996 23.1926C78.5403 24.1967 77.3734 24.8026 76.0245 24.8026C73.8615 24.8026 72.2651 23.1926 72.2651 21.1119C72.2651 19.0313 73.9205 17.4213 75.9638 17.4213V17.4197ZM73.5151 20.4305H78.2402C78.1572 19.2642 77.1914 18.4883 75.9718 18.4883C74.7522 18.4883 73.6954 19.2642 73.5167 20.4305H73.5151Z"
//                 fill="#14171F"
//             />
//             <Path
//                 d="M81.5795 17.5659L83.9979 22.9469L86.4993 17.5659H87.7716L82.9347 27.5977H81.7295L83.3993 24.1352L80.2322 17.5659H81.5795Z"
//                 fill="#14171F"
//             />
//         </Svg>
//     );
// };

// const Logo = () => {
//     return (
//         <Svg width="91" height="23" viewBox="0 0 91 23">
//             <Path
//                 d="M21.1539 5.31319C22.1721 5.31319 22.9976 4.49175 22.9976 3.47845C22.9976 2.46515 22.1721 1.64371 21.1539 1.64371C20.1357 1.64371 19.3103 2.46515 19.3103 3.47845C19.3103 4.49175 20.1357 5.31319 21.1539 5.31319Z"
//                 fill="#14171F"
//             />
//             <Path
//                 d="M53.108 18.7917C54.1262 18.7917 54.9517 17.9703 54.9517 16.957C54.9517 15.9437 54.1262 15.1223 53.108 15.1223C52.0898 15.1223 51.2644 15.9437 51.2644 16.957C51.2644 17.9703 52.0898 18.7917 53.108 18.7917Z"
//                 fill="#14171F"
//             />
//             <Path d="M22.5448 7.19659H19.7629V18.6023H22.5448V7.19659Z" fill="#14171F" />
//             <Path
//                 d="M66.3063 5.696C67.3245 5.696 68.1499 4.87456 68.1499 3.86126C68.1499 2.84796 67.3245 2.02652 66.3063 2.02652C65.2881 2.02652 64.4626 2.84796 64.4626 3.86126C64.4626 4.87456 65.2881 5.696 66.3063 5.696Z"
//                 fill="#14171F"
//             />
//             <Path d="M67.6085 7.19659H64.8267V18.6023H67.6085V7.19659Z" fill="#14171F" />
//             <Path
//                 d="M30.5388 18.9173C28.1859 18.9173 25.615 18.0414 25.0239 17.6624V2.49594H27.8058V7.3381C28.5269 7.09458 29.4307 6.92032 30.5388 6.92032C33.4407 6.92032 36.5254 8.96813 36.5254 12.7624C36.5254 16.9912 33.4223 18.9173 30.5388 18.9173ZM27.8058 15.728C28.4978 15.9243 29.5164 16.1496 30.5388 16.1496C32.7326 16.1496 33.7443 14.5591 33.7443 12.7624C33.7443 10.8303 32.4742 9.68803 30.5388 9.68803C28.9956 9.68803 28.1576 10.1454 27.8058 10.4049V15.7272V15.728Z"
//                 fill="#14171F"
//             />
//             <Path
//                 d="M43.7157 18.9173C40.3924 18.9173 37.6877 16.2265 37.6877 12.9185C37.6877 9.61047 40.3916 6.91962 43.7157 6.91962C47.0397 6.91962 49.7436 9.61047 49.7436 12.9185C49.7436 16.2265 47.0397 18.9173 43.7157 18.9173ZM43.7157 9.68809C41.9256 9.68809 40.4696 11.137 40.4696 12.9185C40.4696 14.6999 41.9256 16.1489 43.7157 16.1489C45.5058 16.1489 46.9617 14.6999 46.9617 12.9185C46.9617 11.137 45.5058 9.68809 43.7157 9.68809Z"
//                 fill="#14171F"
//             />
//             <Path
//                 d="M61.6305 15.9571C61.4798 16.0507 61.1128 16.209 60.5898 16.1725C59.8702 16.1223 59.3915 15.6109 59.3915 14.4039V9.9263H62.4135V7.15782H59.3915V3.66794H56.6096V14.4039C56.6096 17.4098 58.3944 18.912 60.5607 18.912C61.788 18.912 62.3653 18.6792 62.7859 18.4745L61.6297 15.9564L61.6305 15.9571Z"
//                 fill="#14171F"
//             />
//             <Path
//                 d="M72.7863 23H70.0044V8.51766L70.7377 8.12651C70.8302 8.07705 73.0264 6.92035 75.6026 6.92035C77.0822 6.92035 78.5642 7.485 79.6691 8.47048C80.9002 9.56782 81.5785 11.0921 81.5785 12.7624C81.5785 14.4328 81.0088 15.9867 79.9758 17.113C78.9083 18.2766 77.4248 18.9173 75.7991 18.9173C74.6597 18.9173 73.6282 18.6921 72.7863 18.412V23ZM72.7863 15.4343C73.4508 15.7486 74.5435 16.1496 75.7991 16.1496C77.5647 16.1496 78.7974 14.757 78.7974 12.7624C78.7974 11.2511 77.6022 9.68806 75.6026 9.68806C74.4961 9.68806 73.4515 9.99702 72.7863 10.2489V15.4335V15.4343Z"
//                 fill="#14171F"
//             />
//             <Path
//                 d="M86.6139 18.9173C83.9153 18.9173 82.3095 17.524 82.0854 17.3451L84.0568 15.4092C84.4085 15.6398 85.4103 16.1846 86.7622 16.1846C87.5972 16.1846 88.2311 15.9632 88.2311 15.2296C88.2311 13.904 82.9748 14.2007 82.9748 10.3616C82.9748 7.76736 85.3628 6.90897 87.0123 6.90897C89.0715 6.90897 90.3776 8.26048 90.6552 8.57781L88.6815 10.5168C88.4292 10.1713 87.5903 9.64167 86.8111 9.64167C86.4426 9.64167 85.7872 9.74669 85.7872 10.3562C85.7872 11.9528 91 11.3341 91 15.2296C91 16.8307 90.0595 18.9173 86.6146 18.9173H86.6139Z"
//                 fill="#14171F"
//             />
//             <Path
//                 d="M7.98463 18.9638C7.09226 18.9638 5.56749 18.0597 4.27672 16.766C2.3008 14.7852 -0.045218 11.0822 0.000662503 4.68689L2.87507 4.70744C2.84908 8.26657 3.69481 11.3333 5.31974 13.5775C6.37958 15.0401 7.49524 15.7775 7.9984 16.0324C8.42585 15.827 9.30217 15.2806 10.2205 14.1832C11.2299 12.9786 12.6071 10.7923 13.0712 7.22098L15.6169 7.63952C15.0701 12.2374 13.4941 14.8537 12.1162 16.3741C10.5746 18.0742 8.87089 18.9638 7.98387 18.9638H7.98463Z"
//                 fill="#14171F"
//             />
//             <Path
//                 d="M10.628 0C7.7865 0 5.64771 2.12468 5.64771 4.85129H8.4273C8.4273 3.74101 9.37014 2.68857 10.6273 2.68857C12.565 2.68857 13.5009 4.11618 13.1553 7.16774C13.1553 7.16774 14.9247 6.55895 15.7246 6.28651C15.8791 1.61558 13.1132 0 10.628 0Z"
//                 fill="#14171F"
//             />
//             <Path
//                 d="M17.2585 4.71734C16.5963 5.34743 14.3007 7.46754 11.0692 7.19511C9.29058 7.0452 8.42803 5.88165 8.42803 4.85051C7.26267 3.67859 6.0866 4.06821 5.64844 4.85051C5.73943 7.48657 7.41484 9.57091 10.9545 9.85933C15.0784 10.1957 17.9283 7.74683 18.9775 6.84201L17.2593 4.71658L17.2585 4.71734Z"
//                 fill="#14171F"
//             />
//         </Svg>
//     );
// };

const styles = StyleSheet.create({
	body: {
		paddingTop: 48,
		paddingBottom: 60,
		paddingHorizontal: 32,
	},

	pageFooter: {
		position: "absolute",
		bottom: 24,
		left: 32,
		right: 32,
		borderTop: "0.5pt solid #ccc",
		paddingTop: 4,
		alignItems: "flex-end",
	},

	text_12_500: {
		fontSize: 12,
		fontWeight: 500,
		fontFamily: "Euclid",
		color: "#000",
	},

	text_8_400: {
		fontSize: 8,
		fontWeight: 400,
		fontFamily: "Euclid",
		color: "#000",
	},

	text_8_500: {
		fontSize: 8,
		fontWeight: 500,
		fontFamily: "Euclid",
		color: "#000",
	},

	text_6_400: {
		fontSize: 8,
		fontWeight: 400,
		fontFamily: "Euclid",
		color: "#000",
	},

	text_18_600: {
		fontSize: 18,
		fontWeight: 600,
		fontFamily: "Euclid",
		color: "#000",
	},

	header: {
		display: "flex",
		flexDirection: "row",
	},

	headerColumn: {
		display: "flex",
		flex: 1,
		flexDirection: "column",
	},

	Footer: {
		position: "absolute",
		bottom: 48,
		left: 32,
		right: 32,
	},

	Row: {
		display: "flex",
		flexDirection: "row",
		gap: 4,
		paddingBottom: 1,
		paddingTop: 1,
	},
});
